export const EXPERIENCE_SCORE_ERROR_TYPES = {
    NO_INFERENCE_RESULTS_FOUND: 'NO_INFERENCE_RESULTS_FOUND',
    INSUFFICIENT_RECORDS_FOR_INFERENCE: 'INSUFFICIENT_RECORDS_FOR_INFERENCE',
    INSUFFICIENT_RECORDS_FOR_NEW_INFERENCE: 'INSUFFICIENT_RECORDS_FOR_NEW_INFERENCE',
    INSUFFICIENT_RECORDS_FOR_FIRST_INFERENCE: 'INSUFFICIENT_RECORDS_FOR_FIRST_INFERENCE',
} as const;

export const INSUFFICIENT_RECORDS_ERRORS: string[] = [
    EXPERIENCE_SCORE_ERROR_TYPES.INSUFFICIENT_RECORDS_FOR_INFERENCE,
    EXPERIENCE_SCORE_ERROR_TYPES.INSUFFICIENT_RECORDS_FOR_NEW_INFERENCE,
    EXPERIENCE_SCORE_ERROR_TYPES.INSUFFICIENT_RECORDS_FOR_FIRST_INFERENCE,
];
